<div class="container text-center regscale-solution-container">
	<h3 class="regscale-solution-header">
		RegScale is the only solution that holistically
		<br class="d-none d-md-block" />
		manages your compliance program—both manual
		<br class="d-none d-md-block" />
		and automated assessments—at scale.
	</h3>
	<div class="regscale-circle mt-4">
		<i class="d-none d-lg-block fas fa-long-arrow-alt-down fa-2x"></i>
		<i class="d-block d-lg-none fas fa-long-arrow-alt-down fa-1x"></i>
	</div>
	<img
		class="d-none d-xl-block"
		style="position: absolute; top: 5rem"
		src="../../assets/img/solution-illustration.png"
		alt=""
	/>
	<img
		class="d-block d-xl-none solution-illustration-mobile"
		src="../../assets/img/solution-illustration-mobile.png"
		alt=""
	/>
	<div
		class="
			container
			d-flex
			flex-column
			justify-content-between
			solution-middle
		"
	>
		<div class="solution-middle-item1">
			<div
				class="text-gradient"
				style="
					background: -webkit-linear-gradient(
						45deg,
						#20a495 0%,
						#1aa8c6 100%
					);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				"
			>
				Digitize
			</div>
			<div class="my-3 my-lg-4 solution-underline"></div>
			<div>
				Save time and reduce risk by moving your compliance artifacts
				into a digital system of record.
			</div>
		</div>

		<div class="solution-middle-item2 align-self-end">
			<div
				class="text-gradient"
				style="
					background: -webkit-linear-gradient(
						45deg,
						#f3931f 0%,
						#ef5a23 50%,
						#9e0e5d 100%
					);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				"
			>
				Automate
			</div>
			<div class="my-3 my-lg-4 solution-underline "></div>
			<div>
				Integrate with your existing security and compliance tools to
				keep your compliance documentation continuously up to date.
			</div>
		</div>

		<div class="solution-middle-item3">
			<div
				class="text-gradient"
				style="
					background: -webkit-linear-gradient(
						45deg,
						#1a70ad 0%,
						#2aa4ca 100%
					);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				"
			>
				Transform
			</div>
			<div class="my-3 my-lg-4 solution-underline"></div>
			<div>
				Assess once and use across many standards and frameworks, output
				in both human- and machine-readable formats.
			</div>
		</div>

		<div class="solution-middle-item4 align-self-end">
			<div
				class="text-gradient"
				style="
					background: -webkit-linear-gradient(
						45deg,
						#f9ca2d 0%,
						#f8b03b 50%,
						#f3931f 100%
					);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				"
			>
				Scale
			</div>
			<div class="my-3 my-lg-4 solution-underline"></div>
			<div>
				Deployable in any environment with tenants for every business
				unit, with enterprise reporting across the organization in your
				Business Intelligence platform of choice.
			</div>
		</div>
	</div>

	<div class="reduce">
		<img width="100%" src="../../assets/img/reduce.svg" alt="" />
	</div>
	<div class="reduce-mobile">
		<img width="100%" src="../../assets/img/reduce-mobile.svg" alt="" />
	</div>
	<a href="https://go.regscale.com/RegScale-Create-Account">
		<button class="regscale-solution-btn py-2 px-4">
			Get Started Today
			<i class="ml-2 fas fa-long-arrow-alt-right d-none d-lg-block"></i>
			<i
				class="ml-2 fas fa-long-arrow-alt-down d-block d-lg-none"
			></i></button
	></a>
</div>
